module.exports = __webpack_public_path__ + "img/Luxembourg.f4e1e03a.png";